import groupBy from 'lodash/groupBy'

// convert HH:mm to h:mmp, omit minutes if it's 0
const format = time => {
  const [hour, minute] = time.split(':').map(Number)
  const apm = ['am', 'pm'][Math.floor(hour / 12)]
  return (hour === 12 ? hour : hour % 12) + (minute === 0 ? '' : `:${minute}`) + apm
}

export default {
  methods: {
    coalesceHours (store) {
      const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      const open = store.attributes['open-times'].map(format)
      const close = store.attributes['close-times'].map(format)

      const reduced = weekdays
        .map((_, i) => `${open[i]} - ${close[i]}`)
        .reduce((acc, hour, i) => {
          if (acc.length && acc[acc.length - 1]['hour'] === hour) {
            acc[acc.length - 1]['end']++
          } else {
            acc.push({ hour, start: i, end: i })
          }
          return acc
        }, [])

      return reduced.map(({ hour, start, end }) => {
        if (start === end) return `${weekdays[start]}: ${hour}`
        return `${weekdays[start]} ${start === end - 1 ? 'and' : 'to'} ${weekdays[end]}: ${hour}`
      })
    },
    getStoreName (store) {
      if (store.attributes.flagship) {
        return `${store.attributes.name} (${this.$t('bookingService.flagship')})`
      } else {
        return store.attributes.name
      }
    }
  },
  servicesGroupByCategory (store, allServices, sortedCategories) {
    // get this store services
    const serviceIds = store.relationships.services.data.map(s => s.id)
    const services = allServices.filter(s => serviceIds.includes(s.id))
    // group services by category id
    const servicesByCategory = groupBy(services, service => service.relationships.category.data.id)
    // filter only ids of category that's has service in this store
    const sortedCategoryIds = sortedCategories.map(c => c.id).filter(id => servicesByCategory[id])
    return sortedCategoryIds
  }
}
